module.exports = __webpack_public_path__ + "img/banner-life-bellow-water.27b075a6.png";